import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view02ImageOptions } from './views/exterior_view02'

class XC38BowSprit extends Component {
    constructor(props) {
        super(props);
        this.handleBowspritChange = this.handleBowspritChange.bind(this);
    }


    handleBowspritChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Bowsprit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view02ImageOptions;

        let image = <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />;
        
        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='Bowsprit' /></h1>

                    <p><Trans defaults='Hull topsides include 6 large hull portlights and a hull recessed anchor fitting hidden by GRP cowl, exchangeable with a carbon bowsprit to handle asymmetric spinnakers. This is a unique X-Yachts feature unparalleled by the competition.' /></p>

                    <RadioGroup label={this.props.t("Optional bowsprit with teak surface:")} options={this.props.bowSpritOptions} value={this.props.configuration.Bowsprit} onChange={this.handleBowspritChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38BowSprit);


// WEBPACK FOOTER //
// ./src/XC38/XC38BowSprit.js